export default __webpack_public_path__ + "static/media/advantage-icon1.5f6d86d4.svg";